function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import * as StyledComps from '../StyledComps';
import Imagine from '../Imagine';

var Lightbox = /*#__PURE__*/function (_React$Component) {
  _inherits(Lightbox, _React$Component);

  var _super = _createSuper(Lightbox);

  function Lightbox(props) {
    var _this;

    _classCallCheck(this, Lightbox);

    _this = _super.call(this, props);
    _this.el = document.createElement('div');
    return _this;
  }

  _createClass(Lightbox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.appendRef !== undefined && this.props.appendRef.current !== null) {
        this.props.appendRef.current.appendChild(this.el);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.appendRef !== undefined && this.props.appendRef.current !== null) {
        this.props.appendRef.current.removeChild(this.el);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/ReactDOM.createPortal(this.props.children, this.el);
    }
  }]);

  return Lightbox;
}(React.Component);

export var Render = /*#__PURE__*/function (_Component) {
  _inherits(Render, _Component);

  var _super2 = _createSuper(Render);

  function Render(props) {
    var _this2;

    _classCallCheck(this, Render);

    _this2 = _super2.call(this, props);

    _defineProperty(_assertThisInitialized(_this2), "state", {
      isOpen: false,
      current: 0,
      imgClass: 'hidden'
    });

    _defineProperty(_assertThisInitialized(_this2), "setImgSize", function () {
      var pageRef = _this2.props.pageRef;

      if (_typeof(pageRef.current) !== undefined && pageRef.current && _typeof(_this2.imgRef.current) !== undefined && _this2.imgRef.current) {
        var outBCR = pageRef.current.getBoundingClientRect();

        var imgBCR = _this2.imgRef.current.getBoundingClientRect();

        var size = {
          width: imgBCR.width * outBCR.height / imgBCR.height,
          height: outBCR.height
        };

        if (outBCR.width < size.width) {
          size = {
            width: outBCR.width,
            height: imgBCR.height * outBCR.width / imgBCR.width
          };
        }

        _this2.imgRef.current.style.width = "".concat(size.width, "px");
        _this2.imgRef.current.style.height = "".concat(size.height, "px");

        _this2.setState({
          imgClass: 'visible'
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this2), "handleImageLoaded", function (e) {
      _this2.setImgSize();
    });

    _defineProperty(_assertThisInitialized(_this2), "errorAlert", function () {
      var _this2$props = _this2.props,
          debug = _this2$props.debug,
          region = _this2$props.region;

      if (debug) {
        alert("Error: ".concat(JSON.stringify(region.medias)));
      }
    });

    _defineProperty(_assertThisInitialized(_this2), "openLightbox", function () {
      var region = _this2.props.region;

      _this2.props.handleViewerEvent('regionClick', {
        region: region
      });

      _this2.setState({
        isOpen: true
      });
    });

    _defineProperty(_assertThisInitialized(_this2), "closeLightbox", function () {
      _this2.setState({
        isOpen: false
      });
    });

    _defineProperty(_assertThisInitialized(_this2), "nextSlide", function () {
      _this2.goTo(_this2.state.current + 1);
    });

    _defineProperty(_assertThisInitialized(_this2), "previousSlide", function () {
      _this2.goTo(_this2.state.current - 1);
    });

    _defineProperty(_assertThisInitialized(_this2), "goTo", function (index) {
      var medias = _this2.props.medias;
      var current = index;

      if (index < 0) {
        current = medias.length - 1;
      } else if (index >= medias.length) {
        current = 0;
      }

      _this2.setState({
        imgClass: 'hidden',
        current: current
      });
    });

    _this2.lightboxRef = /*#__PURE__*/React.createRef();
    _this2.imgRef = /*#__PURE__*/React.createRef();
    return _this2;
  }

  _createClass(Render, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          region = _this$props.region,
          debug = _this$props.debug,
          pageRef = _this$props.pageRef,
          medias = _this$props.medias,
          multiple = _this$props.multiple;
      var _this$state = this.state,
          isOpen = _this$state.isOpen,
          current = _this$state.current,
          imgClass = _this$state.imgClass;

      if (!medias || !medias.length) {
        return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("button", {
          onClick: this.errorAlert
        }, debug ? region['@id'] : null));
      }

      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("button", {
        onClick: this.openLightbox
      }, debug ? region['@id'] : null), isOpen && pageRef && pageRef.current !== null ? /*#__PURE__*/React.createElement(Lightbox, {
        appendRef: pageRef
      }, /*#__PURE__*/React.createElement(StyledComps.PageLightbox, {
        style: {
          backgroundColor: region.settings.backdropColor ? region.settings.backdropColor : 'rgba(0,0,0,.5)'
        },
        onClick: region.settings.backdropExit ? this.closeLightbox : function () {}
      }, !region.settings.backdropExit ? /*#__PURE__*/React.createElement(StyledComps.PageLightboxClose, {
        onClick: this.closeLightbox
      }) : null, multiple && medias.length > 1 ? /*#__PURE__*/React.createElement(StyledComps.PageLightboxPrevious, {
        onClick: this.previousSlide
      }) : null, multiple && medias.length > 1 ? /*#__PURE__*/React.createElement(StyledComps.PageLightboxNext, {
        onClick: this.nextSlide
      }) : null, /*#__PURE__*/React.createElement(StyledComps.PageLightboxSlideshowWrapper, {
        multiple: multiple
      }, /*#__PURE__*/React.createElement(Imagine, {
        src: medias[current].url,
        width: 800,
        ref: this.imgRef,
        className: imgClass,
        onLoad: this.handleImageLoaded,
        onClick: region.settings.backdropExit ? this.closeLightbox : function () {}
      })))) : null);
    }
  }]);

  return Render;
}(Component);
Render.propTypes = {
  region: PropTypes.object.isRequired,
  onPageChange: PropTypes.func.isRequired,
  handleViewerEvent: PropTypes.func.isRequired,
  pageRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.instanceOf(Element)
  })]),
  modalRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.instanceOf(Element)
  })]),
  debug: PropTypes.bool
};
Render.defaultProps = {
  region: null,
  onPageChange: null,
  debug: false
};
export default Render;